import React from 'react';

const Badge = ({
  children,
  variant = 'primary',
  size = 'medium',
  className = '',
  ...props
}) => {
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    medium: 'px-2.5 py-1 text-sm',
    large: 'px-3 py-1.5 text-base',
  };

  const variantClasses = {
    primary: 'bg-blue-100 text-primary',
    success: 'bg-green-100 text-success',
    danger: 'bg-red-100 text-danger',
    warning: 'bg-yellow-100 text-warning',
    secondary: 'bg-gray-100 text-gray-700',
    info: 'bg-cyan-100 text-info',
  };

  return (
    <span
      className={`badge-base rounded-full font-medium ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
